module.exports = __webpack_public_path__ + "img/02-1.534d9a58.png";